<template>
  <div id="dashboard-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`) },
        { title: this.$t('menu.checkup_plus/patients'), disabled: true }
    ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :active-filters="activeFilters"
          @toggle-filters="toggleFilters" />

        <Searchable class="mr-2" :querySearch.sync="querySearch"/>
      </div>

    </Breadcrumbs>


    <div class="text-center" v-if="isLoading">
      <LoadingAnimation></LoadingAnimation>
    </div>
    <div v-else>
      <PatientsTable
        class="mt-1"
        :service="component.service"
        :querySearch="querySearch"
        :showFilters="showFilters"
        @row-clicked="onPatientClicked"
      />
    </div>


  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import GraphsDashboard from "@/components/checkup_plus/dashboard/GraphsDashboard";
import PatientsTable from "@/components/checkup_plus/patients/PatientsTable";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation";
import RangeDatePicker from "@/components/common/RangeDatePicker";
import Multiselect from 'vue-multiselect'
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import ClustersAndEntitiesMixin from "@/mixins/ClustersAndEntitiesMixin";
import Filters from '@/components/common/Filters'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {CHECkUP_PLUS_PATIENTS_TABLE} from "@/local-storage/LocalStorageKeys";
import Searchable from "@/components/common/Searchable";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";



export default {
  mixins: [
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin,
    IndexTablesMixin
  ],
  components: {
    Searchable,
    RangeDatePicker, LoadingAnimation, PatientsTable, GraphsDashboard, Breadcrumbs, Multiselect, Filters},
  props: {
    component: {
      type: Object,
      required: true,
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  async created() {
    this.isLoading = true
    await this.loadLocalStorage()
    this.isLoading = false
  },
  data: function () {
    return {
      isLoading: false,
      showFilters: true,
      activeFilters: 0,
      querySearch: '',
    }
  },
  methods: {
    onPatientClicked: function ({patient}) {
      this.$router.push({name: `check-up_plus/checkup_plus/patients/id`, params: {id: patient.idPerson}})
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(CHECkUP_PLUS_PATIENTS_TABLE)
        if (state !== null) {
          /*if (state.query) {
            this.querySearch = state.query
          }*/
          this.filters = {
            ...this.filters,
            ...state
          }
        }
        resolve()
      })
    },
  },
  computed: {

  }
}
</script>

<style scoped>

</style>
